import { isEqual } from 'lodash';
import { ICoordinates } from 'pages/special/OsloDesignFair/map/mapTypes';
import { EmptyLayer } from 'pages/special/OsloDesignFair/map/markers/view/EmptyLayer';
import { Layer, Source } from 'react-map-gl';
interface Props {
    beforeId?: string;
    coordinates: ICoordinates[];
    color: string;
    opacity: number;
    markerId: string;
    visible: boolean;
    orderIndex: number;
}

export const GroundFloor = (props: Props) => {
    const sourceId = props.markerId + '|floor';

    const layerIds = {
        layer: props.markerId + '|floor|layer',
        last: props.markerId + '|floor|last'
    };

    const beforeIds = {
        layer: props.beforeId,
        last: layerIds.layer
    };

    const isFirstAndLastTheSame = isEqual(
        props.coordinates[0],
        props.coordinates[props.coordinates.length - 1]
    );

    const coordinates = isFirstAndLastTheSame
        ? props.coordinates
        : [...props.coordinates, props.coordinates[0]];

    return (
        <Source
            id={sourceId}
            type="geojson"
            data={{
                type: 'Feature',
                properties: {
                    orderIndex: props.orderIndex,
                    markerId: props.markerId
                },
                geometry: {
                    type: 'Polygon',
                    coordinates: [coordinates.map(({ lng, lat }) => [lng, lat])]
                }
            }}
        >
            <Layer
                id={layerIds.layer}
                beforeId={beforeIds.layer}
                source={sourceId}
                type="fill"
                paint={{
                    'fill-color': props.color ?? '#fff',
                    'fill-opacity': props.opacity ?? 1
                }}
                layout={{
                    visibility: props.visible ? 'visible' : 'none'
                }}
            />
            <EmptyLayer id={layerIds.last} beforeId={beforeIds.last} />
        </Source>
    );
};
